export default interface GoponRes {
  Result: {
    StatusCode: number;
    StatusMessage: 'Success';
    ValidationErrors: {
      ErrorKey: '';
      ErrorMsg: '';
    }[];
    PagingInfo: {
      PageIndex: number;
      PageSize: number;
      TotalCount: number;
      TotalPages: number;
      HasPreviousPage: boolean;
      HasNextPage: boolean;
    };
  };
  ItemDataList: [
    {
      Id: number;
      Name: string;
      Value: string;
      Label: string;
      Type: string;
      Position: 0;
      Clickable: boolean;
      Image: string;
      CustomList1: string;
      CustomList2: string;
      CustomList3: string;
      CustomAttribute1: string;
      CustomAttribute2: string;
      CustomAttribute3: string;
      CustomAttribute4: string;
      CustomAttribute5: string;
      CustomAttribute6: string;
      CustomAttribute7: string;
      CustomAttribute8: string;
      CustomAttribute9: string;
      CustomAttribute10: string;
    }
  ];
}
export type GoponRes2<T> = {
  Result: {
    StatusCode: number;
    StatusMessage: string;
    ValidationErrors: {
      ErrorKey: string;
      ErrorMsg: string;
    }[];
    PagingInfo?: {
      PageIndex: number;
      PageSize: number;
      TotalCount: number;
      TotalPages: number;
      HasPreviousPage: boolean;
      HasNextPage: boolean;
    };
  };
} & T;
export type DasResError = {
  Result: {
    StatusCode: number;
    StatusMessage: string;
    ValidationErrors: {
      errorKey: '';
      errorMsg: '';
    }[];
    PagingInfo?: {
      PageIndex: number;
      PageSize: number;
      TotalCount: number;
      TotalPages: number;
      HasPreviousPage: boolean;
      HasNextPage: boolean;
    };
  };
};
export class Pagable {
  page: number = 0;
  size: number = 10;
}
